module.exports = __webpack_public_path__ + "static/media/Notes.a346e981.svg";